/**
 * Created by pandemio on 11/12/18.
 */
/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Col, Container, Row} from 'reactstrap';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows, faApple, faAndroid } from '@fortawesome/free-brands-svg-icons';
import Settings from '../../custom-classes/settings';
/**
 * Component to download the page
 */
class PlatformDownloadList extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });

        this.state = {
            linkWindowsDownload: Settings.getDownloadWindowsAppURL(),
            linkMacDownload: Settings.getDownloadMacAppURL(),
            linkGooglePlay:  Settings.getDownloadAndroidAppURL(),
            linkAppStore: Settings.getDownloadIpadsAppUrl()
        };
        this.props.addTranslation(global);
    }


    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        return(
                <div className="container-white container-padding">
                    <Container>
                        <Row className="text-center">
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <h2 className="font-now-bold">
                                    <Translate id="downloads.select-operative-system" options={{renderInnerHtml: true}}/>
                                </h2>
                                <hr/>
                                <h3> <Translate id="downloads.important-read-the-following" options={{renderInnerHtml: true}}/> </h3>
                                    <ul>
                                        <li><Translate id="downloads.important-1" options={{renderInnerHtml: true}}/> </li>
                                        <li><Translate id="downloads.important-2" options={{renderInnerHtml: true}}/></li>
                                        <li><Translate id="downloads.important-3" options={{renderInnerHtml: true}}/></li>
                                    </ul>

                            </Col>
                            <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                <a href={this.state.linkWindowsDownload} className="btn btn-imp font-now-bold btn-success btn-block">
                                    <FontAwesomeIcon icon={faWindows} size="2x" />{'  '}
                                    Windows
                                    <br/>
                                    <small className="small-text">7,8,8.1,10,+</small>
                                </a>
                            </Col>
                            <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                <a href={this.state.linkGooglePlay} className="btn btn-imp font-now-bold btn-success btn-block">
                                    <FontAwesomeIcon icon={faAndroid} size="2x" />
                                    Android
                                    <br/>
                                    <small className="small-text">
                                        <Translate id="downloads.tablets-and-phones" options={{renderInnerHtml: true}}/>
                                    </small>
                                </a>
                            </Col>
                            <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>
                                <a href={this.state.linkMacDownload} className="btn btn-imp font-now-bold btn-success btn-block">
                                    <FontAwesomeIcon icon={faApple} size="2x" />{'  '}
                                    Mac
                                    <br/>
                                    <small className="small-text">
                                        <Translate id="downloads.apple-computers" options={{renderInnerHtml: true}}/>
                                    </small>
                                </a>
                            </Col>
                            <Col lg={{size: 6}} md={{size:6}} sm={{size:12}} xs={{size:12}}>{'  '}
                                <a href={this.state.linkAppStore} className="btn btn-imp font-now-bold btn-success btn-block">
                                    <FontAwesomeIcon icon={faApple} size="2x" />{'  '}
                                    <br/>
                                    iPads & iPhones
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </div>
        )
    };
}

export default withLocalize(PlatformDownloadList);


// WEBPACK FOOTER //
// ./src/components/item-list/platform-download-list.js